import { render, staticRenderFns } from "./dictItemsList.vue?vue&type=template&id=5a03e373&scoped=true&"
import script from "./dictItemsList.vue?vue&type=script&lang=js&"
export * from "./dictItemsList.vue?vue&type=script&lang=js&"
import style0 from "./dictItemsList.vue?vue&type=style&index=0&id=5a03e373&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a03e373",
  null
  
)

export default component.exports